import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface PaymentListingCSVRequest {
  token: string;
  externalAccount: string;
  totalPages: number;
  totalRowCount: number;
  startDate?: string;
  endDate?: string;
}

const downloadPaymentsListingCSV = async ({
  token,
  externalAccount,
  totalPages,
  totalRowCount,
  startDate,
  endDate,
}: PaymentListingCSVRequest) => {
  let url = `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/downloadPaymentsListingCSV`;

  try {
    const params: any = {
      externalAccount,
      totalPages,
      totalRowCount,
    };

    if (startDate) {
      params.startDate = startDate;
    }

    if (endDate) {
      params.endDate = endDate;
    }

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
      responseType: "blob",
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default downloadPaymentsListingCSV;
